module.exports = __webpack_public_path__ + "media/images/icon-twitter-e612d845130f11dfa5425f7a1958bc21.png";